import React from 'react';
import PropTypes from 'prop-types';
import Booth608Template from './templates/Booth608Template';
import Booth001Template from './templates/Booth001Template';
import Booth002Template from './templates/Booth002Template';

const BoothTemplateSwitch = ({
  booth,
  handleClick,
  showRepsImg,
}) => {
  const renderTemplate = () => {
    switch (booth.template) {
      case '002':
        return (
          <Booth002Template
            booth={booth}
            handleClick={handleClick}
            showRepsImg={showRepsImg}
          />
        );
      case '001':
        return (
          <Booth001Template
            booth={booth}
            handleClick={handleClick}
            showRepsImg={showRepsImg}
          />
        );
      default:
        return (
          <Booth608Template
            booth={booth}
            handleClick={handleClick}
            showRepsImg={showRepsImg}
          />
        );
    }
  };

  return (
    <>
      {
        renderTemplate()
      }
    </>
  );
};

BoothTemplateSwitch.propTypes = {
  booth: PropTypes.shape().isRequired,
  handleClick: PropTypes.func,
  showRepsImg: PropTypes.bool,
};

BoothTemplateSwitch.defaultProps = {
  handleClick: () => {},
  showRepsImg: false,
};

export default BoothTemplateSwitch;
